import { MfsCollection, MfsCollectionKind, MfsCollectionQuery } from '../mfsTypes';
import { Result } from '../../errors';
import { isPositiveInteger } from '../../utility';
import { mfsError } from '../../errors/storeErrors';
import { throwIfInvalidQuery } from '../query';

/** Verify that collection kind is valid. */
export function isValidCollection(collection: MfsCollection): Result {
  if (collection.kind !== MfsCollectionKind.OrderedList) {
    return Result.fail(mfsError.invalidCollectionKind());
  }

  return Result.ok();
}

export function throwIfInvalidCollectionQuery(query?: MfsCollectionQuery): void {
  if (!query) return;

  if (query.depth !== undefined && !isPositiveInteger(query.depth)) {
    throw mfsError.invalidQueryDepth(query.depth);
  }

  if (query.select !== undefined || query.skip !== undefined || query.top !== undefined) {
    throwIfInvalidQuery(query);
  }
}

/** Prevent adding a collection to itself */
export function throwIfHasSelfReference(collectionId: string, itemIds: string[]): void {
  if (itemIds.some((id) => id === collectionId)) {
    throw mfsError.circularReference();
  }
}
